import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Element} from 'react-scroll';
import { Tooltip } from 'react-tippy';
import Aux from '../../../components/Hoc/Aux';
import LearnMore from '../../../components/Forms/LearnMore';
import ReasonsResults from '../../../components/Reasons/ReasonsResults';
import ScrollButton from '../../../components/Header/ScrollButton';
import Accordion from '../../../components/Accordion/Accordion';
// import medicareRating from '../../../assets/svg/icon-medicare-rating-sm.svg';
import cdphpLogo from '../../../assets/logo.svg';

class MedicareCompareWesternNY extends Component {
  componentDidMount () {
    if (!document.getElementById('wistia_script')) {
      var wistiaScript = document.createElement('script');
      wistiaScript.id = 'wistia_script';
      wistiaScript.type = 'text/javascript';
      wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      wistiaScript.async = true;
      document.body.appendChild(wistiaScript);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Medicare Compare Western NY',
      'eventValue': undefined
    });
  }

  render () {
    const accordionData = [
      {
        index: 1,
        title: 'What is Medicare Advantage?',
        content: `Medicare plans take four forms. Part A (hospital coverage) and Part B (outpatient coverage) plans are offered by the federal government and are what most people think of as “original” Medicare. Part D (prescription coverage) plans were introduced to offset the cost of medications. Part C (Medicare Advantage) plans are offered by commercial insurers like CDPHP that combine all the benefits of Original Medicare Parts A and B, and often also include Part D, along other benefits like dental and vision, for a single monthly premium. `
      },
      {
        index: 3,
        title: 'Will I need a primary care physician (PCP)?',
        content: `Medicare Advantage PPO plans do not require you to name a PCP.`
      },
      {
        index: 4,
        title: 'What will my prescription drugs cost?',
        content: <div><p>With CDPHP Medicare Advantage prescription drug coverage, your dollars go further. Rx for Less offers significant discounts on certain generic drugs at select local pharmacies—and many cost as low as a dollar a fill. Use our <a href='https://www.cdphp.com/medicare/drug-coverage' target='_blank' rel='noopener noreferrer'>online drug lookup tool</a> to see if your prescription drugs are covered.</p><p>If you’d rather not visit the pharmacy, you can also sign up for automatic mail-order delivery of most prescriptions through Wal-Mart Home Delivery. Most members pay $0 for Tier 1 and Tier 2 drugs.</p></div>
      },
      {
        index: 5,
        title: 'How do I confirm my doctors are in your network?',
        content: <p>Thousands of doctors and most major hospitals in the 33-county CDPHP service area are included in our network. Our <a href='https://findadoc.cdphp.com' target='_blank' rel='noopener noreferrer'>Find-A-Doc</a> search tool makes it easy to confirm that your preferred providers are all “in”.</p>
      },
      {
        index: 6,
        title: 'Will I be covered when I’m traveling out of the area?',
        content: `Our Medicare Advantage PPO plans cover a national network of providers, as well as emergency coverage when you’re outside of the United States.`
      },
      {
        index: 7,
        title: 'How do I enroll?',
        content: `You can enroll in a Medicare Advantage plan during the annual open enrollment period, which runs from October 15 through December 7 each year. Or, you may have access to a special enrollment period due to events such as turning 65, loss of employer coverage, or a recent move.`
      }
    ];

    return (
      <Aux>
        <header className='locked landingPage'>
          <div className='main'>
            <div>
              <Link to='/' className='logo'>
                <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
              </Link>
              {/* <p className='eligible'>Enroll anytime before December 7th!</p> */}
            </div>
            <div className='connect'>
              <p>
                <strong>Need help selecting the right Medicare plan?</strong>
                <span><a href='tel:888-519-7898' className='tel phoneswap'>888-519-7898</a> | TTY: 711 <em>M-F, 8 a.m. – 8 p.m.<sup>‡</sup></em></span>
              </p>
            </div>
            <ScrollButton
              text='Contact Me'
              scrollName='learnForm'
              scrollOpts={{
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -200
              }} />
          </div>
        </header>

        <article id='medicareCompare'>
          <section className='intro'>
            <div className='wrap'>
              <h1>Compare Our Most Popular<br /> Medicare Advantage Plans</h1>
            </div>
            <div className='wrap sm'>
              <div className='callout'>
                <p className='calloutContent'>Medicare Advantage plans cover more than Original Medicare, protecting you from unexpected&nbsp;costs.</p>
                <span className='medicareVideo wistia_embed wistia_async_zxz20nalns popover=true popoverContent=link'>
                  <img src='https://embed-fastly.wistia.com/deliveries/b4fb8e6d78596003281e2128d94c2985.jpg?image_play_button_size=2x&amp;image_crop_resized=960x540&amp;image_play_button=1&amp;image_play_button_color=00A255e0' width='400' height='225' />
                </span>
              </div>
            </div>
          </section>

          <section>
            <div className='wrap sm'>
              <div className='results medicare container'>
                <div className='table'>
                  <table>
                    <thead>
                      <tr className='heading'>
                        <th className='item'>
                          <p className='note'><strong>Note:</strong> Original Medicare is required for any Medicare Advantage Plan</p>
                        </th>
                        <th>
                          <div className='card medicare'>
                            <h4>Original Medicare <span>Parts A &amp; B</span></h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>Vital Rx (PPO)*</h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>Complete Rx (PPO)*</h4>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className='subhead'>
                        <td className='item'>&nbsp;</td>
                        <td><h6><strong>Original Medicare</strong></h6><strong>$185<sup>.00</sup></strong><Tooltip html={(<span className='originalMedicare'>Most people pay the standard Part B monthly premium amount ($185.00 in 2024). Visit <a href='https://www.medicare.gov/your-medicare-costs/costs-at-a-glance/costs-at-glance.html' target='_blank' rel='noopener noreferrer'>Medicare.gov</a> to learn more.</span>)} arrow='true' interactive='true'><span className='helpTip'>Estimated Monthly Cost</span></Tooltip></td>
                        <td className='hmp'><h6>Vital Rx (PPO)*</h6><strong>$0</strong> <span>Monthly Cost</span></td>
                        <td className='ppo'><h6>Complete Rx (PPO)*</h6><strong>$70<sup>.00</sup></strong> <span>Monthly Cost</span></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Medical Deductible</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>$233</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Deductible</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Drug Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$300</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>No Deductible</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Annual Physicals</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Out of Network Coverage</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>Yes</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>Yes</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Primary Care Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Specialist Doctor Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$45</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$40</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Dental Allowance</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$725 / year</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$1,400 / year</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Eyeware Allowance</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$125 / year</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$225 / year</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Drugs</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$0 - 40%</strong></Tooltip></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$0 - 45%</strong></Tooltip></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Over-the-Counter Allowance</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6>No Coverage</td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$50 / quarter</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Hospital Stays</h5></td>
                        <td className='med'><h6>Original Medicare:</h6><Tooltip title='With Original Medicare, you will have a $1,364 deductible for the first 60 days, $341/day from days 61-90, and $682/day for each “lifetime reserve day” after day 90 for each benefit period (up to 60 days over your lifetime) for inpatient hospitalizations. CDPHP Medicare plans protect you from potentially high, unexpected costs by instead offering a flat, predictable copay.' arrow='true'><span className='helpTip'>See Details</span></Tooltip></td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$500 per day,<br /> days 1-5, then $0</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$310 per day,<br /> days 1-6, then $0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Outpatient Surgeries</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$335 - $360</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$275 - $325</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Urgent Care</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$55</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$55</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Worldwide Emergency Care</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$120</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$120</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Maximum Annual<br />Out-of-Pocket Protection</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Protection</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><strong>$6,750</strong></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><strong>$6,000</strong></td>
                      </tr>
                      {/* <tr>
                        <td className='item'><h5>Centers for Medicare &amp; Medicaid Services Rating<sup>†</sup></h5></td>
                        <td className='med'><h6>Original Medicare:</h6>N/A</td>
                        <td className='hmo'><h6>Vital Rx (PPO):</h6><img src={medicareRating} alt='4.5 out of 5 Medicare Ranking' /></td>
                        <td className='ppo'><h6>Complete Rx (PPO):</h6><img src={medicareRating} alt='4.5 out of 5 Medicare Rankin' /></td>
                      </tr> */}
                    </tbody></table>
                  <p className='medicare-desc'>*Your cost share (copays and coinsurances) may be different for Out-of-Network services.</p>
                </div>
              </div>
            </div>
          </section>

          <section className='compare-expenses'>
            <div className='wrap sm'>
              <div className='container'>
                <div className='navigate expenses medicare-expenses'>
                  <h4>Looking for other Medicare plan options? </h4>
                  <p><a href='/pdf/CDPHP_2025_Medicare_Rochester_Plan_Options_Brochure.pdf' target='_blank' rel='noopener noreferrer'>Explore all our plans</a> or <a href={'https://cdphpmedicare1.destinationrx.com/PC/2025/Shopping/PlanList?ZipCode=14602&AgentID=cdphpfunnel'} target='_blank' rel='noopener noreferrer'>enroll online</a> if you’re ready.</p>
                </div>
              </div>
            </div>
          </section>

          <Element name='learnForm'>
            <LearnMore
              area='MedicareQuoteWesternNY'
              MedicareCompare='true'
              phone='888-519-7898 | TTY: 711' />
          </Element>
          <ReasonsResults intro="More Reasons Why You'll Love Us" type='medicareWNY' />

          <section id='faq'>
            <div className='wrap sm'>
              <h2>Frequently Asked Questions</h2>
              {accordionData.map(({ index, title, content }) => (
                <Accordion
                  key={index}
                  id={'faq' + index}
                  title={title}
                  content={content} />
              ))}
            </div>
          </section>
        </article>
      </Aux>
    );
  }
}

export default MedicareCompareWesternNY;


// WEBPACK FOOTER //
// ./src/containers/Views/Landing/MedicareCompareWesternNY.jsx